import type { Lang } from '../types';

export interface ForgotPasswordText {
  title: string;
  subtitleDefault: string;
  subtitleSent: string;
  emailLabel: string;
  emailPlaceholder: string;
  submitBtn: string;
  submittingBtn: string;
  sentBody: (email: string) => string;
  backToLogin: string;
}

export const forgotPasswordText: Record<Lang, ForgotPasswordText> = {
  cs: {
    title: 'Zapomenuté heslo?',
    subtitleDefault: 'Zadejte e-mail a zašleme vám odkaz pro obnovení hesla',
    subtitleSent: 'Zkontrolujte svou schránku',
    emailLabel: 'E-mailová adresa',
    emailPlaceholder: 'vy@priklad.cz',
    submitBtn: 'Odeslat odkaz',
    submittingBtn: 'Odesílám…',
    sentBody: email => `Pokud je adresa ${email} registrována, byl na ni odeslán odkaz pro obnovení hesla. Odkaz je platný 24 hodin.`,
    backToLogin: 'Zpět na přihlášení',
  },
  en: {
    title: 'Forgot password?',
    subtitleDefault: "Enter your email and we'll send you a reset link",
    subtitleSent: 'Check your inbox',
    emailLabel: 'Email address',
    emailPlaceholder: 'you@example.com',
    submitBtn: 'Send reset link',
    submittingBtn: 'Sending…',
    sentBody: email => `If ${email} is registered, a password reset link has been sent. The link is valid for 24 hours.`,
    backToLogin: 'Back to sign in',
  },
  vi: {
    title: 'Quên mật khẩu?',
    subtitleDefault: 'Nhập email và chúng tôi sẽ gửi link đặt lại mật khẩu',
    subtitleSent: 'Kiểm tra hộp thư của bạn',
    emailLabel: 'Địa chỉ email',
    emailPlaceholder: 'ban@example.com',
    submitBtn: 'Gửi link đặt lại',
    submittingBtn: 'Đang gửi…',
    sentBody: email => `Nếu ${email} đã được đăng ký, một link đặt lại mật khẩu đã được gửi. Link có hiệu lực trong 24 giờ.`,
    backToLogin: 'Quay lại đăng nhập',
  },
  uk: {
    title: 'Забули пароль?',
    subtitleDefault: 'Введіть email і ми надішлемо посилання для скидання пароля',
    subtitleSent: 'Перевірте вашу скриньку',
    emailLabel: 'Електронна адреса',
    emailPlaceholder: 'ви@example.com',
    submitBtn: 'Надіслати посилання',
    submittingBtn: 'Надсилаю…',
    sentBody: email => `Якщо адреса ${email} зареєстрована, на неї надіслано посилання для скидання пароля. Посилання дійсне 24 години.`,
    backToLogin: 'Назад до входу',
  },
};
